import InvoicesPage from "./Invoices";
export default InvoicesPage;
